import Axios from 'axios'
import {
	ICrudApplyProductAttrFilters,
	ICrudApplyProductAttrIndividual,
	ICrudProductAttrGlobalAssign,
	ICrudProductAttrGlobalAssignConfirm,
	ICrudProductAttrGlobalAssignEdit,
	ICrudProductAttrGlobalAssignPaginate
} from 'models/ProductGlobalUploadInterface'

export const productAttrGlobalApply = async (
	params: ICrudApplyProductAttrFilters
) => {
	const response = await Axios.post(
		`conf_atrib_global_producto/seleccionar`,
		params
	)
	return response.data
}

export const productAttrIndividualApply = async (
	params: ICrudApplyProductAttrIndividual
) => {
	const response = await Axios.post(
		`Conf_atrib_global_producto/editar/confirmar `,
		params
	)
	return response.data
}
export const productAttrGlobalAssign = async (
	params: ICrudProductAttrGlobalAssign
) => {
	const response = await Axios.post(
		`Conf_atrib_global_producto/asignaGlobal `,
		params
	)
	return response.data
}
export const productAttrGlobalAssignConfirm = async (
	params: ICrudProductAttrGlobalAssignConfirm
) => {
	const response = await Axios.post(
		`Conf_atrib_global_producto/confirmar `,
		params
	)
	return response.data
}

export const productAttrGlobalAssignEdit = async (
	params: ICrudProductAttrGlobalAssignEdit
) => {
	const response = await Axios.get(
		`Conf_atrib_global_producto/editar?idOperacion=${params.idOperacion}&niprod=${params.niprod}`
	)
	return response.data
}
export const productAttrGlobalAssignPaginate = async (
	params: ICrudProductAttrGlobalAssignPaginate
) => {
	const response = await Axios.post(
		`Conf_atrib_global_producto/paginar `,
		params
	)
	return response.data
}
